import { CheckboxToggleInput } from '@/components/CheckboxToggleInput'

import { VehicleLabelsConfig } from './LayerManager.types'
import { hasAnyVehicleLabel } from './LayerManager.utils'

import styles from './LayerManager.module.css'

export const VehicleLabelControls = ({
  showRegistration,
  showShareReference,
  setShowRegistration,
  setShowShareReference,
  clearVehicleLabels,
  showTags = false,
  setShowTags,
}: VehicleLabelsConfig) => {
  const hasAny = hasAnyVehicleLabel({ showRegistration, showShareReference, showTags })

  return (
    <div className={styles.vehicleLabelsSection} data-testid="vehicle-label-controls">
      <div className={styles.vehicleLabelsHeader}>
        <span>Vehicle Labels</span>
        <button
          type="button"
          className={styles.offButton}
          disabled={!hasAny}
          onClick={clearVehicleLabels}
          data-testid="vehicle-labels-off-button"
        >
          Off
        </button>
      </div>
      <div className={styles.childOptionsLayerToggleWrapper}>
        <CheckboxToggleInput
          className={styles.layerToggle}
          checked={showRegistration}
          onChange={(e) => setShowRegistration(e.target.checked)}
          data-testid="layer-manager-show-registration-toggle"
        >
          Show Vehicle Registration
        </CheckboxToggleInput>
        <CheckboxToggleInput
          className={styles.layerToggle}
          checked={showShareReference}
          onChange={(e) => setShowShareReference(e.target.checked)}
          data-testid="layer-manager-show-share-reference-toggle"
        >
          Show Share Reference
        </CheckboxToggleInput>
        {setShowTags ? (
          <CheckboxToggleInput
            className={styles.layerToggle}
            checked={showTags}
            onChange={(e) => setShowTags(e.target.checked)}
            data-testid="layer-manager-show-tags-toggle"
          >
            Show Tags
          </CheckboxToggleInput>
        ) : null}
      </div>
    </div>
  )
}
